import { Question } from '../types';

export const subjectPredicateQuestions: Question[] = [
  {
    id: 'sp1',
    text: 'According to Al-Ajrumiyyah, what is the المبتدأ (subject)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb that comes at the beginning of a sentence', isCorrect: false },
      { id: 'b', text: 'The noun that comes at the beginning of a sentence', isCorrect: false },
      { id: 'c', text: 'The noun that is devoid of governing agents', isCorrect: true },
      { id: 'd', text: 'The noun that is governed by a verb', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines المبتدأ (subject) as "الاسم المجرد عن العوامل اللفظية" - the noun that is devoid of governing agents.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp2',
    text: 'According to Al-Ajrumiyyah, what is the الخبر (predicate)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The verb that comes at the beginning of a sentence', isCorrect: false },
      { id: 'b', text: 'The noun that comes at the beginning of a sentence', isCorrect: false },
      { id: 'c', text: 'The part that completes the meaning with the subject', isCorrect: true },
      { id: 'd', text: 'The noun that is governed by a verb', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الخبر (predicate) as "هو الجزء الذي تتم به الفائدة مع المبتدأ" - the part that completes the meaning with the subject.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp3',
    text: 'According to Al-Ajrumiyyah, what are the types of الخبر (predicate)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'مفرد (single)', isCorrect: true },
      { id: 'b', text: 'جملة (sentence)', isCorrect: true },
      { id: 'c', text: 'شبه جملة (semi-sentence)', isCorrect: true },
      { id: 'd', text: 'مركب (compound)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the types of الخبر (predicate) are: مفرد (single), جملة (sentence), and شبه جملة (semi-sentence).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp4',
    text: 'According to Al-Ajrumiyyah, what is meant by جملة (sentence) as a type of predicate?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'جملة اسمية (nominal sentence)', isCorrect: true },
      { id: 'b', text: 'جملة فعلية (verbal sentence)', isCorrect: true },
      { id: 'c', text: 'جملة شرطية (conditional sentence)', isCorrect: false },
      { id: 'd', text: 'جملة استفهامية (interrogative sentence)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that جملة (sentence) as a type of predicate includes: جملة اسمية (nominal sentence) and جملة فعلية (verbal sentence).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp5',
    text: 'According to Al-Ajrumiyyah, what is meant by شبه جملة (semi-sentence) as a type of predicate?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'ظرف (adverb)', isCorrect: true },
      { id: 'b', text: 'جار ومجرور (preposition and the noun it governs)', isCorrect: true },
      { id: 'c', text: 'جملة اسمية (nominal sentence)', isCorrect: false },
      { id: 'd', text: 'جملة فعلية (verbal sentence)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that شبه جملة (semi-sentence) as a type of predicate includes: ظرف (adverb) and جار ومجرور (preposition and the noun it governs).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp6',
    text: 'In the sentence زيدٌ قائمٌ (Zayd is standing), identify the مبتدأ (subject) and خبر (predicate) according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'زيدٌ is the مبتدأ and قائمٌ is the خبر', isCorrect: true },
      { id: 'b', text: 'قائمٌ is the مبتدأ and زيدٌ is the خبر', isCorrect: false },
      { id: 'c', text: 'Both زيدٌ and قائمٌ are مبتدأ', isCorrect: false },
      { id: 'd', text: 'Both زيدٌ and قائمٌ are خبر', isCorrect: false }
    ],
    explanation: 'In the sentence زيدٌ قائمٌ, زيدٌ is the مبتدأ (subject) because it is the noun that is devoid of governing agents, and قائمٌ is the خبر (predicate) because it is the part that completes the meaning with the subject.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp7',
    text: 'In the sentence زيدٌ في الدار (Zayd is in the house), identify the type of the خبر (predicate) according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مفرد (single)', isCorrect: false },
      { id: 'b', text: 'جملة (sentence)', isCorrect: false },
      { id: 'c', text: 'شبه جملة (semi-sentence)', isCorrect: true },
      { id: 'd', text: 'مركب (compound)', isCorrect: false }
    ],
    explanation: 'In the sentence زيدٌ في الدار, the خبر (predicate) is في الدار, which is شبه جملة (semi-sentence) because it consists of a preposition (في) and the noun it governs (الدار).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp8',
    text: 'In the sentence زيدٌ أبوه قائمٌ (Zayd\'s father is standing), identify the type of the خبر (predicate) according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مفرد (single)', isCorrect: false },
      { id: 'b', text: 'جملة (sentence)', isCorrect: true },
      { id: 'c', text: 'شبه جملة (semi-sentence)', isCorrect: false },
      { id: 'd', text: 'مركب (compound)', isCorrect: false }
    ],
    explanation: 'In the sentence زيدٌ أبوه قائمٌ, the خبر (predicate) is أبوه قائمٌ, which is جملة (sentence) because it is a complete nominal sentence (جملة اسمية) consisting of a subject (أبوه) and a predicate (قائمٌ).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp9',
    text: 'In the sentence زيدٌ قام أبوه (Zayd\'s father stood up), identify the type of the خبر (predicate) according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مفرد (single)', isCorrect: false },
      { id: 'b', text: 'جملة (sentence)', isCorrect: true },
      { id: 'c', text: 'شبه جملة (semi-sentence)', isCorrect: false },
      { id: 'd', text: 'مركب (compound)', isCorrect: false }
    ],
    explanation: 'In the sentence زيدٌ قام أبوه, the خبر (predicate) is قام أبوه, which is جملة (sentence) because it is a complete verbal sentence (جملة فعلية) consisting of a verb (قام) and a subject (أبوه).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp10',
    text: 'In the sentence زيدٌ عندك (Zayd is with you), identify the type of the خبر (predicate) according to Al-Ajrumiyyah:',
    type: 'single',
    options: [
      { id: 'a', text: 'مفرد (single)', isCorrect: false },
      { id: 'b', text: 'جملة (sentence)', isCorrect: false },
      { id: 'c', text: 'شبه جملة (semi-sentence)', isCorrect: true },
      { id: 'd', text: 'مركب (compound)', isCorrect: false }
    ],
    explanation: 'In the sentence زيدٌ عندك, the خبر (predicate) is عندك, which is شبه جملة (semi-sentence) because it consists of an adverb (عند) and a pronoun suffix (ك).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp11',
    text: 'According to Al-Ajrumiyyah, when can the خبر (predicate) precede the مبتدأ (subject)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When the خبر is شبه جملة (semi-sentence)', isCorrect: true },
      { id: 'b', text: 'When the مبتدأ is a pronoun', isCorrect: false },
      { id: 'c', text: 'When the مبتدأ is indefinite and the خبر is definite', isCorrect: true },
      { id: 'd', text: 'When the مبتدأ is restricted', isCorrect: true }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the خبر (predicate) can precede the مبتدأ (subject) in several cases, including when the خبر is شبه جملة (semi-sentence), when the مبتدأ is indefinite and the خبر is definite, and when the مبتدأ is restricted (محصور).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp12',
    text: 'In the sentence في الدار رجلٌ (In the house is a man), why does the خبر (predicate) precede the مبتدأ (subject) according to Al-Ajrumiyyah?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Because the خبر is شبه جملة (semi-sentence)', isCorrect: true },
      { id: 'b', text: 'Because the مبتدأ is indefinite', isCorrect: true },
      { id: 'c', text: 'Because the مبتدأ is a pronoun', isCorrect: false },
      { id: 'd', text: 'Because the مبتدأ is restricted', isCorrect: false }
    ],
    explanation: 'In the sentence في الدار رجلٌ, the خبر (predicate) في الدار precedes the مبتدأ (subject) رجلٌ because the خبر is شبه جملة (semi-sentence) and the مبتدأ is indefinite (نكرة).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp13',
    text: 'According to Al-Ajrumiyyah, what are the nawasikh (cancelers) that affect the مبتدأ and خبر?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'كان وأخواتها (kana and its sisters)', isCorrect: true },
      { id: 'b', text: 'إن وأخواتها (inna and its sisters)', isCorrect: true },
      { id: 'c', text: 'ظن وأخواتها (dhanna and its sisters)', isCorrect: true },
      { id: 'd', text: 'لم ولما (lam and lamma)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that the nawasikh (cancelers) that affect the مبتدأ and خبر are: كان وأخواتها (kana and its sisters), إن وأخواتها (inna and its sisters), and ظن وأخواتها (dhanna and its sisters).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp14',
    text: 'According to Al-Ajrumiyyah, what does كان وأخواتها (kana and its sisters) do to the مبتدأ and خبر?',
    type: 'single',
    options: [
      { id: 'a', text: 'It makes the مبتدأ منصوب (accusative) and the خبر مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'It makes the مبتدأ مرفوع (nominative) and the خبر منصوب (accusative)', isCorrect: true },
      { id: 'c', text: 'It makes both the مبتدأ and the خبر مرفوع (nominative)', isCorrect: false },
      { id: 'd', text: 'It makes both the مبتدأ and the خبر منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that كان وأخواتها (kana and its sisters) makes the مبتدأ مرفوع (nominative) and the خبر منصوب (accusative).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp15',
    text: 'According to Al-Ajrumiyyah, what does إن وأخواتها (inna and its sisters) do to the مبتدأ and خبر?',
    type: 'single',
    options: [
      { id: 'a', text: 'It makes the مبتدأ منصوب (accusative) and the خبر مرفوع (nominative)', isCorrect: true },
      { id: 'b', text: 'It makes the مبتدأ مرفوع (nominative) and the خبر منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'It makes both the مبتدأ and the خبر مرفوع (nominative)', isCorrect: false },
      { id: 'd', text: 'It makes both the مبتدأ and the خبر منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that إن وأخواتها (inna and its sisters) makes the مبتدأ منصوب (accusative) and the خبر مرفوع (nominative).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp16',
    text: 'According to Al-Ajrumiyyah, in which case is it obligatory to place the predicate before the subject?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When the predicate is a question word (استفهام)', isCorrect: true },
      { id: 'b', text: 'When the subject is indefinite (نكرة) and the predicate is a prepositional phrase (شبه جملة)', isCorrect: true },
      { id: 'c', text: 'When the subject contains a pronoun (ضمير) that refers to something in the predicate', isCorrect: true },
      { id: 'd', text: 'When the predicate is a proper noun (اسم علم)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that it is obligatory to place the predicate before the subject in these cases: when the predicate is a question word, when the subject is indefinite and the predicate is a prepositional phrase, and when the subject contains a pronoun that refers to something in the predicate.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp17',
    text: 'In the sentence أين زيدٌ (Where is Zayd?), why is the predicate placed before the subject according to Al-Ajrumiyyah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Because the predicate is a question word (استفهام)', isCorrect: true },
      { id: 'b', text: 'Because the subject is indefinite (نكرة)', isCorrect: false },
      { id: 'c', text: 'Because the subject contains a pronoun (ضمير) that refers to something in the predicate', isCorrect: false },
      { id: 'd', text: 'Because the predicate is a prepositional phrase (شبه جملة)', isCorrect: false }
    ],
    explanation: 'In the sentence أين زيدٌ, the predicate أين is placed before the subject زيدٌ because the predicate is a question word (استفهام).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp18',
    text: 'According to Al-Ajrumiyyah, what happens to the subject and predicate after the entry of كان وأخواتها (kana and its sisters)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The subject becomes منصوب (accusative) and the predicate becomes مرفوع (nominative)', isCorrect: false },
      { id: 'b', text: 'The subject becomes اسم كان مرفوع (the nominative noun of kana) and the predicate becomes خبر كان منصوب (the accusative predicate of kana)', isCorrect: true },
      { id: 'c', text: 'Both the subject and predicate become مرفوع (nominative)', isCorrect: false },
      { id: 'd', text: 'Both the subject and predicate become منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that after the entry of كان وأخواتها, the subject becomes اسم كان مرفوع (the nominative noun of kana) and the predicate becomes خبر كان منصوب (the accusative predicate of kana).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp19',
    text: 'According to Al-Ajrumiyyah, what happens to the subject and predicate after the entry of إن وأخواتها (inna and its sisters)?',
    type: 'single',
    options: [
      { id: 'a', text: 'The subject becomes اسم إن منصوب (the accusative noun of inna) and the predicate becomes خبر إن مرفوع (the nominative predicate of inna)', isCorrect: true },
      { id: 'b', text: 'The subject becomes مرفوع (nominative) and the predicate becomes منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'Both the subject and predicate become منصوب (accusative)', isCorrect: false },
      { id: 'd', text: 'Both the subject and predicate become مرفوع (nominative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that after the entry of إن وأخواتها, the subject becomes اسم إن منصوب (the accusative noun of inna) and the predicate becomes خبر إن مرفوع (the nominative predicate of inna).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp20',
    text: 'According to Al-Ajrumiyyah, what are كان وأخواتها (kana and its sisters)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'كان (kana)', isCorrect: true },
      { id: 'b', text: 'أمسى (amsa)', isCorrect: true },
      { id: 'c', text: 'أصبح (asbaha)', isCorrect: true },
      { id: 'd', text: 'أضحى (adha)', isCorrect: true },
      { id: 'e', text: 'ظل (zalla)', isCorrect: true },
      { id: 'f', text: 'بات (bata)', isCorrect: true },
      { id: 'g', text: 'صار (sara)', isCorrect: true },
      { id: 'h', text: 'ليس (laysa)', isCorrect: true },
      { id: 'i', text: 'إن (inna)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists كان وأخواتها (kana and its sisters) as: كان, أمسى, أصبح, أضحى, ظل, بات, صار, and ليس.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp21',
    text: 'According to Al-Ajrumiyyah, what are إن وأخواتها (inna and its sisters)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'إن (inna)', isCorrect: true },
      { id: 'b', text: 'أن (anna)', isCorrect: true },
      { id: 'c', text: 'كأن (ka\'anna)', isCorrect: true },
      { id: 'd', text: 'لكن (lakinna)', isCorrect: true },
      { id: 'e', text: 'ليت (layta)', isCorrect: true },
      { id: 'f', text: 'لعل (la\'alla)', isCorrect: true },
      { id: 'g', text: 'كان (kana)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists إن وأخواتها (inna and its sisters) as: إن, أن, كأن, لكن, ليت, and لعل.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp22',
    text: 'According to Al-Ajrumiyyah, what happens to the مبتدأ (subject) and خبر (predicate) after the entry of ظن وأخواتها (dhanna and its sisters)?',
    type: 'single',
    options: [
      { id: 'a', text: 'They both become منصوب (accusative) as مفعول به (direct objects)', isCorrect: true },
      { id: 'b', text: 'The subject becomes منصوب (accusative) and the predicate becomes مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'The subject becomes مرفوع (nominative) and the predicate becomes منصوب (accusative)', isCorrect: false },
      { id: 'd', text: 'They both remain مرفوع (nominative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that after the entry of ظن وأخواتها, both the subject and predicate become منصوب (accusative) as مفعول به (direct objects).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp23',
    text: 'According to Al-Ajrumiyyah, what are ظن وأخواتها (dhanna and its sisters)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'ظن (dhanna)', isCorrect: true },
      { id: 'b', text: 'حسب (hasiba)', isCorrect: true },
      { id: 'c', text: 'خال (khala)', isCorrect: true },
      { id: 'd', text: 'زعم (za\'ama)', isCorrect: true },
      { id: 'e', text: 'رأى (ra\'a)', isCorrect: true },
      { id: 'f', text: 'علم (\'alima)', isCorrect: true },
      { id: 'g', text: 'وجد (wajada)', isCorrect: true },
      { id: 'h', text: 'كان (kana)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah lists ظن وأخواتها (dhanna and its sisters) as: ظن, حسب, خال, زعم, رأى, علم, and وجد.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp24',
    text: 'According to Al-Ajrumiyyah, in the sentence كان زيدٌ قائماً (Zayd was standing), identify اسم كان and خبر كان:',
    type: 'single',
    options: [
      { id: 'a', text: 'زيدٌ is اسم كان and قائماً is خبر كان', isCorrect: true },
      { id: 'b', text: 'قائماً is اسم كان and زيدٌ is خبر كان', isCorrect: false },
      { id: 'c', text: 'Both زيدٌ and قائماً are اسم كان', isCorrect: false },
      { id: 'd', text: 'Both زيدٌ and قائماً are خبر كان', isCorrect: false }
    ],
    explanation: 'In the sentence كان زيدٌ قائماً, زيدٌ is اسم كان (the noun of kana) because it is the subject, and قائماً is خبر كان (the predicate of kana) because it is the predicate.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp25',
    text: 'According to Al-Ajrumiyyah, in the sentence إن زيداً قائمٌ (Indeed, Zayd is standing), identify اسم إن and خبر إن:',
    type: 'single',
    options: [
      { id: 'a', text: 'زيداً is اسم إن and قائمٌ is خبر إن', isCorrect: true },
      { id: 'b', text: 'قائمٌ is اسم إن and زيداً is خبر إن', isCorrect: false },
      { id: 'c', text: 'Both زيداً and قائمٌ are اسم إن', isCorrect: false },
      { id: 'd', text: 'Both زيداً and قائمٌ are خبر إن', isCorrect: false }
    ],
    explanation: 'In the sentence إن زيداً قائمٌ, زيداً is اسم إن (the noun of inna) because it is the subject, and قائمٌ is خبر إن (the predicate of inna) because it is the predicate.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp26',
    text: 'According to Al-Ajrumiyyah, in the sentence ظننتُ زيداً قائماً (I thought Zayd was standing), identify the two objects of ظننتُ:',
    type: 'single',
    options: [
      { id: 'a', text: 'زيداً is the first object and قائماً is the second object', isCorrect: true },
      { id: 'b', text: 'قائماً is the first object and زيداً is the second object', isCorrect: false },
      { id: 'c', text: 'Both زيداً and قائماً are the first object', isCorrect: false },
      { id: 'd', text: 'Both زيداً and قائماً are the second object', isCorrect: false }
    ],
    explanation: 'In the sentence ظننتُ زيداً قائماً, زيداً is the first object and قائماً is the second object of ظننتُ.',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp27',
    text: 'According to Al-Ajrumiyyah, what is the effect of اسم الفاعل (the active participle) when it functions like a verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'It makes its subject مرفوع (nominative) and its object منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'It makes its subject منصوب (accusative) and its object مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'It makes both its subject and object مرفوع (nominative)', isCorrect: false },
      { id: 'd', text: 'It makes both its subject and object منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that when اسم الفاعل (the active participle) functions like a verb, it makes its subject مرفوع (nominative) and its object منصوب (accusative), as in زيدٌ ضاربٌ عمراً (Zayd is hitting Amr).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp28',
    text: 'According to Al-Ajrumiyyah, what is the effect of اسم المفعول (the passive participle) when it functions like a verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'It makes its subject مرفوع (nominative)', isCorrect: true },
      { id: 'b', text: 'It makes its subject منصوب (accusative)', isCorrect: false },
      { id: 'c', text: 'It makes its subject مجرور (genitive)', isCorrect: false },
      { id: 'd', text: 'It makes its subject مجزوم (jussive)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that when اسم المفعول (the passive participle) functions like a verb, it makes its subject مرفوع (nominative), as in زيدٌ مضروبٌ (Zayd is being hit).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp29',
    text: 'According to Al-Ajrumiyyah, what is the effect of الصفة المشبهة (the assimilated adjective) when it functions like a verb?',
    type: 'single',
    options: [
      { id: 'a', text: 'It makes its subject مرفوع (nominative) and its object منصوب (accusative)', isCorrect: true },
      { id: 'b', text: 'It makes its subject منصوب (accusative) and its object مرفوع (nominative)', isCorrect: false },
      { id: 'c', text: 'It makes both its subject and object مرفوع (nominative)', isCorrect: false },
      { id: 'd', text: 'It makes both its subject and object منصوب (accusative)', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah explains that when الصفة المشبهة (the assimilated adjective) functions like a verb, it makes its subject مرفوع (nominative) and its object منصوب (accusative), as in زيدٌ حسنٌ وجهاً (Zayd is handsome of face).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  },
  {
    id: 'sp30',
    text: 'According to Al-Ajrumiyyah, what are the conditions for a مبتدأ (subject) to be dropped?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When it is understood from the context', isCorrect: true },
      { id: 'b', text: 'When it is the answer to a question', isCorrect: true },
      { id: 'c', text: 'When it is preceded by a verb', isCorrect: false },
      { id: 'd', text: 'When it is indefinite', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah mentions that a مبتدأ (subject) can be dropped when it is understood from the context or when it is the answer to a question, as in من قائم؟ زيدٌ (Who is standing? Zayd), where the complete answer would be زيدٌ قائم (Zayd is standing).',
    ajrumiyyahReference: 'Chapter on Subject and Predicate (باب المبتدأ والخبر)',
    topic: 'subject-predicate'
  }
];
